import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createBlock as _createBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-320c0275"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "grid w-full grid-cols-4 grid-rows-3 background" }
const _hoisted_2 = { class: "col-start-1 row-start-1 col-span-full" }
const _hoisted_3 = {
  key: 0,
  class: "top-trim"
}
const _hoisted_4 = { class: "col-span-3 col-start-1 row-start-2" }
const _hoisted_5 = { class: "flex flex-row items-center w-full h-full" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "hole-punch" }, null, -1))
const _hoisted_7 = {
  key: 1,
  class: "divider xl:hidden"
}
const _hoisted_8 = { class: "author" }

import { PropType, ref } from 'vue';
import IconComponent from '../icon/IconComponent.vue';
import Icon from '../icon/Icon';
import { useGlobalStore } from '../../store/globalStore';
import { storeToRefs } from 'pinia';
import Message from '../../models/Message';
import { getIconOrDefault } from '@/models/Qualifier';
import { formatDate_DD_MMM_YYYY } from '../../utils/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'FeedbackCardComponent',
  props: {
  feedback: {
    type: Object as PropType<Message>,
    required: true
  }
},
  setup(__props) {

const props = __props

const store = useGlobalStore();
const { currentUser } = storeToRefs(store);



const formattedDate = formatDate_DD_MMM_YYYY(props.feedback.issueDate);

const isExpanded = ref(false);
const toggleExpanded = () => {
  if (isExpanded.value === false) {
    store.expandInstructorFeedbackEvent(currentUser.value?.uid || '');
  }
  isExpanded.value = !isExpanded.value;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (isExpanded.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        (!isExpanded.value)
          ? (_openBlock(), _createBlock(IconComponent, {
              key: 0,
              icon: _unref(getIconOrDefault)(__props.feedback.qualifier),
              class: "ml-2 xl:hidden"
            }, null, 8, ["icon"]))
          : _createCommentVNode("", true),
        (!isExpanded.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["flex flex-col w-full xl:ml-2", {
            'ml-4': isExpanded.value
          }])
        }, [
          _createElementVNode("p", _hoisted_8, "From: " + _toDisplayString(__props.feedback.author), 1),
          _createElementVNode("p", {
            class: _normalizeClass(["date", {
              'text-military-green-500': !isExpanded.value,
              'text-sage-500': isExpanded.value
            }])
          }, " Date: " + _toDisplayString(_unref(formattedDate)), 3),
          _createElementVNode("p", {
            class: _normalizeClass(["message", {
              preview: !isExpanded.value,
              full: isExpanded.value
            }])
          }, _toDisplayString(__props.feedback.message), 3)
        ], 2)
      ])
    ]),
    _createElementVNode("div", {
      class: "mr-2 expand-button place-self-end",
      onClick: toggleExpanded
    }, [
      _createVNode(IconComponent, {
        icon: isExpanded.value ? _unref(Icon).MINUS_CIRCLE : _unref(Icon).PLUS_CIRCLE,
        class: "col-start-2 row-start-2"
      }, null, 8, ["icon"])
    ])
  ]))
}
}

})